export async function getEmojis(authToken: string): Promise<string[]> {
  const response = await fetch(`${import.meta.env.VITE_API}/data/getEmojis`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  })

  if (!response.status) throw new Error(response.statusText)

  const emojis: string[] = await response.json()

  localStorage.setItem("emojis", JSON.stringify(emojis))

  return emojis
}
